import { GPTGameButton } from './GPTGameButton';
import { GptGameButtonProps } from '../types';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { WheelEventIcon } from './GPTEventIcons/WheelEventIcon';

export const WheelOfFortuneButton = ({ isCollapsed, isEventActive }: GptGameButtonProps) => {
  const { startRegistration } = useAuthFlow();

  return (
    <GPTGameLauncher
      gameName="wheelOfFortune"
      renderButton={({ Icon, title, ...props }) => (
        <GPTGameButton
          {...props}
          isCompact={isCollapsed}
          Icon={isEventActive ? WheelEventIcon : Icon}
          title={isEventActive ? 'gpt.wheelOfFortuneEventTitle' : title}
        />
      )}
      openRegistration={startRegistration}
    />
  );
};
